import { sortBy, uniqWith } from "lodash";
import { BeachSite } from "./BeachSite";

export interface Council {
    CouncilId: number;
    CouncilName: string;
    Sites: BeachSite[];    
}

export interface Region {
    RegionId: string;
    RegionName: string;
    RegionType? : string;
    ParentRegionId? : string;
    Sites: BeachSite[];
}


export function isRegion(object: any) : object is Region {	
    return 'RegionId' in object && 'RegionName' in object;	
}

export function isCouncil(object: any) : object is Council {	
    return 'CouncilId' in object && 'CouncilName' in object;	
}

export enum RegionTypes {
	REGION = "region",
	SUB_REGION = "sub region"
}

export const isSubRegion = (region : Region) => {
	return RegionTypes.SUB_REGION?.toLowerCase() === region?.RegionType?.toLowerCase();
}

export const getBeachSitesInArea = (sites : BeachSite[], allRegions : Region[], area : Council | Region, isCouncil = false) =>
{
	return sortBy(uniqWith(sites, (a : BeachSite, b : BeachSite) => { return a.Identifier === b.Identifier; })?.filter((site : BeachSite) => 
	{	
		let isMatch = false;	
		if(isCouncil)
		{
			isMatch = site?.Council?.toLocaleLowerCase() === ((<Council>area).CouncilName).toLocaleLowerCase();
		}	
		else
		{
			const region = <Region>area;
			if(isSubRegion(region))
			{				
				isMatch = site?.SubRegion?.toString()?.toLowerCase() === region?.RegionName?.toLowerCase();				
			}
			else if(RegionTypes.REGION?.toLowerCase() === region?.RegionType?.toLowerCase())
			{				
				const subRegions = allRegions.filter((a : Region) => isSubRegion(a) && 
					a.ParentRegionId?.toString()?.toLowerCase() === region.RegionId?.toString()?.toLowerCase());
				isMatch = (site?.ParentRegion?.toString()?.toLowerCase() === region?.RegionName?.toLowerCase()) ||
					subRegions.some((b : Region) => site.SubRegion?.toString()?.toLowerCase() === b?.RegionName?.toLowerCase());
				
			}	
		}
		return isMatch;
	})?.map((a : BeachSite) => ({...a })), "SiteName");
}	

export const areaHasActiveSites = (allBeachSites : BeachSite[], allRegions : Region[], area : Council | Region, isCouncil = false) => {
	let hasSites = false;
	if(isCouncil)
	{
		hasSites = allBeachSites.some((a : BeachSite) => a?.Council?.toLocaleLowerCase() === ((<Council>area).CouncilName).toLocaleLowerCase());
	}
	else
	{	
		const region = <Region>area;	
		if(isSubRegion(region))
		{								
			hasSites = allBeachSites.some((a : BeachSite) => {
				const matches = (a.SubRegion?.toString()?.toLowerCase() === region?.RegionName?.toString()?.toLowerCase());
				return matches;
			});
		}
		else if(RegionTypes.REGION?.toLowerCase() === region?.RegionType?.toLowerCase())
		{		
			const subRegions = allRegions.filter((a : Region) => isSubRegion(a) && 
				a.ParentRegionId?.toString()?.toLowerCase() === region.RegionId?.toString()?.toLowerCase());
			
			hasSites = allBeachSites.some((a : BeachSite) => {											
				const matches = (a.ParentRegion?.toString()?.toLowerCase() === region?.RegionName?.toLowerCase()) ||
				subRegions.some((b : Region) => a.SubRegion?.toString()?.toLowerCase() === b?.RegionName?.toLowerCase());
				return matches;
			});
		}
	}

	return hasSites;
}